<template>
  <div class="layout">
    <router-view />
  </div>
</template>

<script>

export default {
  mounted () {
    let token = localStorage.getItem('token')
    if (!token) {
      this.$router.push({
        path: '/login'
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.layout
  width 100%
  height 100%
  overflow auto
  padding-top 66px
  box-sizing border-box
</style>
